import { useCallback, useEffect, useRef, useState } from "react";

export function useAppointmentTimeError() {
  const [errorSelectTimeNoLongerAvailable, setErrorSelectTimeNoLongerAvailable] =
    useState<boolean>(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const showError = useCallback((duration: number, onTimeout?: () => void) => {
    setErrorSelectTimeNoLongerAvailable(true);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      setErrorSelectTimeNoLongerAvailable(false);
      if (onTimeout) {
        onTimeout();
      }
    }, duration);
  }, []);

  useEffect(
    () => () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    },
    []
  );

  return {
    errorSelectTimeNoLongerAvailable,
    showError
  };
}
